export default "__VITE_ASSET__BM9_kunY__"